import { render, staticRenderFns } from "./SOCScreen6.vue?vue&type=template&id=418239a7&"
import script from "./SOCScreen6.vue?vue&type=script&lang=js&"
export * from "./SOCScreen6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports